import { Flex, Typography, Button, Popconfirm } from "antd";
import { FileTextOutlined, DeleteOutlined } from "@ant-design/icons";
import { institutionalVerificationService } from "../services/institutional-verification.service";

const CertificateInfo = ({
  data,
  institutionId,
  onPreview,
  messageApi,
  isAllowedAction,
}) => {
  const handleDelete = async () => {
    try {
      await institutionalVerificationService.deleteCertificateData(
        institutionId
      );
      messageApi.success("Sertifikat berhasil dihapus");
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      console.error("DELETE ERROR:", error);
      messageApi.error("Gagal menghapus sertifikat");
    }
  };

  return (
    <Flex vertical gap={12}>
      <Flex align="center" gap={8}>
        <FileTextOutlined />
        <Typography.Text strong>{data.fileName}</Typography.Text>
      </Flex>

      <Typography.Text type="secondary">
        Tanggal Upload:{" "}
        {new Date(data.certificateUploadedTime).toLocaleString("id-ID")}
      </Typography.Text>

      <Flex
        style={{
          marginTop: 12,
        }}
        gap={8}
      >
        <Button
          variant="outlined"
          color="primary"
          size="small"
          htmlType="button"
          onClick={() => onPreview(data.filePath)}
        >
          Lihat
        </Button>

        {isAllowedAction && (
          <Popconfirm
            title="Hapus Sertifikat"
            description="Apakah Anda yakin ingin menghapus sertifikat ini?"
            okText="Hapus"
            cancelText="Batal"
            okButtonProps={{ danger: true }}
            onConfirm={handleDelete}
          >
            <Button size="small" danger htmlType="button">
              Hapus
            </Button>
          </Popconfirm>
        )}
      </Flex>
    </Flex>
  );
};

export default CertificateInfo;
